import { Decimal } from 'decimal.js'

export type PurchaseCalculationBasis = 'unitPrice' | 'amount'
export type PurchaseCalculationForm = { quantity: string; unitPrice: string; amount: string; actualBaseQuantity?: string }

function decimal(value: string) {
  try { return value === '' ? null : new Decimal(value) } catch { return null }
}

export function inferPurchaseBasis(form: PurchaseCalculationForm): PurchaseCalculationBasis {
  const quantity = decimal(form.quantity)
  const unitPrice = decimal(form.unitPrice)
  const amount = decimal(form.amount)
  if (!quantity || !unitPrice || !amount) return amount ? 'amount' : 'unitPrice'
  const calculated = quantity.mul(unitPrice).toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
  return calculated.eq(amount) ? 'unitPrice' : 'amount'
}

export function recalculatePurchase(
  form: PurchaseCalculationForm,
  changed: 'quantity' | 'unitPrice' | 'amount',
  previousBasis: PurchaseCalculationBasis,
  otherEditedField?: 'quantity' | 'unitPrice' | 'amount',
) {
  if (changed === 'quantity') form.actualBaseQuantity = ''
  const basis: PurchaseCalculationBasis = changed === 'unitPrice' ? 'unitPrice' : changed === 'amount' ? 'amount' : previousBasis
  const quantity = decimal(form.quantity)
  const unitPrice = decimal(form.unitPrice)
  const amount = decimal(form.amount)
  const deriveQuantity = (changed === 'amount' && otherEditedField === 'unitPrice') || (changed === 'unitPrice' && otherEditedField === 'amount') || (!quantity && changed !== 'quantity')
  if (deriveQuantity) {
    if (unitPrice?.gt(0) && amount?.gte(0)) {
      form.quantity = amount.div(unitPrice).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString()
      form.actualBaseQuantity = ''
    }
    return basis
  }

  if (basis === 'unitPrice') {
    const unitPrice = decimal(form.unitPrice)
    if (quantity && unitPrice) form.amount = quantity.mul(unitPrice).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toFixed(2)
  } else {
    const amount = decimal(form.amount)
    if (quantity?.gt(0) && amount) form.unitPrice = amount.div(quantity).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toFixed(2)
  }

  return basis
}
